import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PaymentTable from '@accounting/components/tables/payment-table/payment-table.vue';

@Component({
  name: 'bpc-payments',
  components: {
    'bpc-payment-table': PaymentTable,
  },
})
export default class Payments extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
